import { Rest } from "utilities/rest";
import * as ActionCreator from "utilities/action.creator";
import { $failure, $requesting, $success } from "../form/action";
import { $processing, $done } from "services/activity/action";

export const MODULE = "Schedule";

const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, "reset", () =>
  $reset.action()
);

export const $showMe = ActionCreator.Async(MODULE, "ShowMe", (payload) => {
  return async (dispatch) => {
    dispatch($processing($showMe.OPERATION));

    return await Rest.GET(`${API_URL}/fleet/schedule/me`, payload)
      .then((response) => {
        dispatch($showMe.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return error;
      })
      .finally(() => dispatch($done($showMe.OPERATION)));
  };
});

export const $getReport = ActionCreator.Async(MODULE, "GetReport", (payload) => {
  return async (dispatch) => {
    dispatch($processing($getReport.OPERATION));

    return await Rest.GET(`${API_URL}/fleet/schedule/report/driver`, payload)
      .then((response) => {
        dispatch($getReport.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return error;
      })
      .finally(() => dispatch($done($getReport.OPERATION)));
  };
});

export const $tapIn = ActionCreator.Async(MODULE, "TapIn", (payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.POST(`${API_URL}/fleet/schedule/tap-in`, payload)
      .then((response) => {
        dispatch($tapIn.success({ response: response?.data }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return error;
      });
  };
});

export const $tapOut = ActionCreator.Async(MODULE, "TapOut", (id, payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.PUT(`${API_URL}/fleet/schedule/${id}/tap-out`, payload)
      .then((response) => {
        dispatch($tapOut.success({ response: response?.data }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return error;
      });
  };
});

export const $updateReport = ActionCreator.Async(MODULE, "UpdateReport", (id, payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.PUT(`${API_URL}/fleet/schedule/report/${id}`, payload)
      .then((response) => {
        dispatch($updateReport.success({ response: response?.data }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return error;
      });
  };
});

export const $showReport = ActionCreator.Async(MODULE, "ShowReport", (id) => {
  return async (dispatch) => {
    dispatch($processing($showReport.OPERATION));

    return await Rest.GET(`${API_URL}/fleet/schedule/report/${id}`)
      .then((response) => {
        dispatch($showReport.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return error;
      })
      .finally(() => dispatch($done($showReport.OPERATION)));
  };
});
